













































import { Component, Prop, Watch } from 'vue-property-decorator';
import { InputNumberCpt } from '@/core/components';
import AppVue from '@/AppVue.vue';
import { SimpleLookupModel } from '@/core/models';

@Component({
  components: {
    InputNumberCpt,
  },
})
export default class SkillAmountsCpt extends AppVue {
  @Prop() inputPrefixId: string;
  @Prop() rowText: string;
  @Prop() strategyLevels: SimpleLookupModel[];
  @Prop() model: Array<undefined | boolean>;
  @Prop({ default: false }) disabled: boolean;

  internalModel: any[] = [];

  created() {
    this.initializeModel();
  }

  @Watch('model')
  onModelChange() {
    this.initializeModel();
  }

  initializeModel() {
    this.internalModel = [this.model];
  }

  getHeading(label: string) {
    return label.split('(')[0];
  }

  getSubHeading(label: string) {
    return `(${label.split('(')[1]}`;
  }
}
